import FormPropertyPriceList from './FormPropertyPriceList';

export default FormPropertyPriceList;
